var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id,staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":tab.path}},[_vm._v(" "+_vm._s(tab.title)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }